<template>

    <div class="card mb-3 mb-lg-4">

        <div class="card-header">
            <div class="row align-items-center">
                <div class="col-6">

                    <inertia-link :href="route('suppliers.show', group.supplier)">
                        <div class="text-dark">
                            <span>
                                {{ __('Verkauf & Versand durch') }}
                            </span>
                            <span>
                                {{ group.supplier.name }}
                            </span>
                        </div>
                        <div class="mt-2" v-if="group.supplier.logo">
                            <img class="" :src="group.supplier.logo" alt="" style="max-height: 40px; width: auto;" v-if="group.supplier.logo" />
                            <div v-else class="h3">
                                {{ group.supplier.name }}
                            </div>
                        </div>
                    </inertia-link>

                    <div class="mt-2 small">
                        <a :href="group.supplier.terms_url" class="" target="_blank" v-if="group.supplier.terms_url">
                            <i class="bi bi-box-arrow-up-right"></i>
                            {{ __('AGB des Lieferanten') }}
                        </a>
                    </div>
                </div>
                <div class="col-6 text-end">
                    <div>
                        <div>
                            {{ __('Summe') }}
                        </div>
                        <div class="mt-0 h3">
                            {{ group.subtotal | localizeAmount }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card-body">

            <div class="">

                <div v-for="cartItem in group.cart_items" :key="cartItem.id" class="py-3">

                    <div class="row">

                        <div class="col-2">
                            <inertia-link :href="cartItem.product.permalink" v-if="cartItem.product_available">
                                <img class="img-fluid thumbnail" :src="cartItem.product.main_image_url" alt="" loading="lazy" />
                            </inertia-link>
                        </div>
                        <div class="col-10">
                            <h5>
                                <inertia-link :href="cartItem.product.permalink" class="link-dark">
                                    {{ cartItem.product.name }}
                                </inertia-link>
                            </h5>
                            <div class="small">
                                <span class="text-nowrap">
                                    {{ __('Lieferanten-Artikelnr.: :number', {number: cartItem.supplier_pid}) }}
                                </span>
                                <!--                                &nbsp;&nbsp;
                                                                <span class="text-nowrap">
                                                                    {{ __('Marktplatz-Artikelnr. :number', {number: cartItem.product.sku}) }}
                                                                </span>-->
                            </div>
                            <tax-info :product="cartItem.product" />
                            <delivery-info :product="cartItem.product" />
                            <div class="mt-2 d-flex justify-content-between align-items-center">
                                <div>
                                    <span>
                                        {{ __('Einzelpreis: :price', {price: $options.filters.localizeAmount(cartItem.price)}) }}
                                    </span>
                                    <span class="text-secondary text-nowrap" v-if="cartItem.price_quantity > 1">
                                        {{ __('je :quantity Stck.', {quantity: cartItem.price_quantity}) }}
                                    </span>
                                    &middot;
                                    <span>
                                        {{ __('Anzahl: :quantity', {quantity: cartItem.quantity}) }}
                                    </span>
                                    <inertia-link :href="route('cart.index')">
                                        {{ __('ändern') }}
                                    </inertia-link>
                                </div>
                                <div>
                                    <button 
                                        type="button"
                                        class="btn btn-sm btn-outline-danger"
                                        @click="deleteCartItem(cartItem.id)"
                                        >
                                        <i class="bi bi-x-lg"></i>
                                        {{ __('Entfernen') }}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </div>

            <div class="">

                <div class="mb-3 bg-light p-3">
                    <div class="mb-2">
                        {{ __('Wählen Sie eine Zahlungsart für alle Produkte von :supplier', {supplier: group.supplier.name}) }}
                    </div>

                    <div class="d-grid gap-2">
                        <div v-for="paymentMethod in group.supplier.payment_methods">
                            <div class="form-check">
                                <input class="form-check-input"
                                       type="radio" 
                                       :value="paymentMethod.id" 
                                       v-model="group.payment_method_id" 
                                       @change="$emit('update-checkout', $event.target.value)"
                                       :id="`payment-method-${group.supplier.id}-${paymentMethod.id}`"
                                       />
                                <label class="form-check-label fw-bold" :for="`payment-method-${group.supplier.id}-${paymentMethod.id}`">
                                    {{ paymentMethod.name }}
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mb-3 bg-light p-3" v-if="group.delivery_options.length > 0">
                    <div class="mb-2">
                        {{ __('Wählen Sie eine Versandart für alle Produkte von :supplier', {supplier: group.supplier.name}) }}
                    </div>
                    <div class="d-grid gap-2">
                        <div class="" v-for="deliveryOption in group.delivery_options">
                            <div class="form-check">
                                <input class="form-check-input" 
                                       type="radio"
                                       :value="deliveryOption.id" 
                                       v-model="group.delivery_option_id" 
                                       @change="$emit('update-checkout', $event.target.value)"
                                       :id="`delivery-option-${group.supplier.id}-${deliveryOption.id}`"
                                       />
                                <label class="form-check-label" :for="`delivery-option-${group.supplier.id}-${deliveryOption.id}`">
                                    <div>
                                        <span class="fw-bold">
                                            {{ deliveryOption.name }}
                                        </span>
                                        <span>
                                            {{ deliveryOption.amount | localizeAmount }}    
                                        </span>
                                        <span v-if='deliveryOption.delivery_time'>
                                            - {{ __('Lieferung innerhalb :days Werktagen', {days: deliveryOption.delivery_time}) }}
                                        </span>
                                    </div>
                                    <div v-if="deliveryOption.description" class="mt-1">
                                        {{ deliveryOption.description }}
                                    </div>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="">
                    <textarea-input :label="__('Bemerkungen an :supplier', {supplier: group.supplier.name})" v-model="group.notes" rows="3" />
                </div>

            </div>

        </div>
    </div>

</template>


<script>

    import TaxInfo from '@/shared/TaxInfo';
    import DeliveryInfo from '@/shared/DeliveryInfo';
    import RadioInput from '@/shared/Inputs/RadioInput';
    import RadiosInput from '@/shared/Inputs/RadiosInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';

    export default {
        props: [
            'group',
        ],
        data() {
            return {
            }
        },
        components: {
            TaxInfo,
            DeliveryInfo,
            RadioInput,
            RadiosInput,
            TextareaInput,
        },
        computed: {

        },
        methods: {
            deleteCartItem(id) {
                this.$inertia.delete(route('cart.remove-item', id), {preserveScroll: false, preserveState: false});
            },
        },
    }
</script>